module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAATCAMAAACwcE1OAAAAAXNSR0IB2cksfwAAAGBQTFRFAAAAOFenOVenOVeofYas5bN15LN1RWKtwsvkkKHOqbbZnKvTzdXpwcrjUmyyaHqw+rZZd4zDXne4////8/X6ztXp9OvhqKq/5+v0hJbItcDe8/T5a4G9f5PHOFinOlinLzpI7AAAACB0Uk5TAND/z///////////////////////////////////YICs1QaeAAAAhElEQVR4nM3QyQ7CMAwE0DIsWdwGkkkhaUP7/39Jzz7kgpDw9WnGsocTOnMeegr8AV+uNwPrvEDGCWFyKn1/xMSYRbI4eM66/PnyBazLGoFiqdna4hubmVkjE5NitzJEGnNE7TqyKk7HPsmN5JuLFNGHtYCQ0GIwzSDp8m/e8iPe9s5sH6b/DYBF6ExGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/visa-icon.png
// module id = 281
// module chunks = 33